/**
 * Écran des parties non livrées.
 *
 * Il existe pour que les entrées de menu inactives mènent quelque part et le
 * DISENT : un lien mort ou une page vide feraient croire à une panne.
 */
export function AVenir() {
  return (
    <section className="bg-white rounded-lg shadow-sm border border-slate-100 p-8 max-w-2xl">
      <h2 className="text-lg font-semibold text-slate-800 mb-2">
        Cette partie n’est pas encore livrée
      </h2>
      <p className="text-sm text-slate-600 mb-4">
        L’espace prestataire démarre par le tableau de bord et les interventions. Les autres écrans
        du menu — clients, rapports, factures, documents, certifications, messagerie, notifications
        — arriveront chacun avec son lot, son serveur et ses tests.
      </p>
      <p className="text-sm text-slate-600">
        Rien n’est simulé ici : une entrée marquée « bientôt » dans le menu est une entrée dont la
        fonctionnalité n’existe pas encore.
      </p>
    </section>
  );
}
